import React from 'react'
import TaxListTable from './Components/TaxListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const TaxList = () => {
  return (
    <PageBody
      card={true}
      isForm={false}
      headerchildren={
        <>
          <HeadingOne>Tax List</HeadingOne>
          <AddItemBtn url="add-Tax" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <TaxListTable />
      </div>
    </PageBody>
  );
};

export default TaxList;
